export interface Step {
  title: string
  subTitle: string
  image: string
}

export const cycleToWorkSteps: Step[] = [
  {
    title: "platform.payrollpay.store.landing.c2w.steps.stepOne.title",
    subTitle: "platform.payrollpay.store.landing.c2w.steps.stepOne.subTitle",
    image: "platform.payrollpay.store.landing.c2w.steps.stepOne.image.src"
  },
  {
    title: "platform.payrollpay.store.landing.c2w.steps.stepTwo.title",
    subTitle: "platform.payrollpay.store.landing.c2w.steps.stepTwo.subTitle",
    image: "platform.payrollpay.store.landing.c2w.steps.stepTwo.image.src"
  },
  {
    title: "platform.payrollpay.store.landing.c2w.steps.stepThree.title",
    subTitle: "platform.payrollpay.store.landing.c2w.steps.stepThree.subtitle",
    image: "platform.payrollpay.store.landing.c2w.steps.stepThree.image.src"
  },
  {
    title: "platform.payrollpay.store.landing.c2w.steps.stepFour.title",
    subTitle: "platform.payrollpay.store.landing.c2w.steps.stepFour.subtitle",
    image: "platform.payrollpay.store.landing.c2w.steps.stepFour.image.src"
  }
]
